import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import {localFullDateLong, isoDate, isToday} from 'utils/LocalDateTimeHelper';
import { canonicalLink, metaDescription } from 'utils/seoUtils';
import JsonLD from 'modules/Common/components/JsonLD';

import GreyhoundRacingRacecardsMeetingSummary from './GreyhoundRacingRacecardsMeetingSummary';

require('./GreyhoundRacingRacecardsForDate.scss');

export default class RacecardsForDate extends Component {
  static propTypes = {
    date: PropTypes.string,
    dateIncrement: PropTypes.number,
    meetingsByDate: PropTypes.object.isRequired,
    raceType: PropTypes.string,
    routes: PropTypes.array.isRequired
  };

  render() {
    var title;

    const racecardsDate = this.props.date ? isoDate(this.props.date) : isoDate(new Date()),
          meetings = this.props.meetingsByDate[racecardsDate] == null ? null : this.props.meetingsByDate[racecardsDate].meetings;


    if(isToday(racecardsDate)){
      title = 'Today\'s Racecards'
    }else{
      title = `${localFullDateLong(racecardsDate)} Racecards`;
    }
    const canonicalURL = {...canonicalLink(this.props.routes, {date: racecardsDate})};

    const { link:
            [
              {
                href: url = ''
              } = {}
            ] = []
          } = canonicalURL;

    const courseList = [];

    if (meetings === null || meetings === undefined) {
      return (
        <div className="gh-racing-racecards">
          Failed to load results.
        </div>)
    }

    meetings.forEach(({ meeting_summary: { course: { name = ''} = {}}} = {}) => courseList.push(name));


    const helmetProps = {
      title,
      ...metaDescription(`Racecards, form, betting and tips for meetings at ${courseList}`)
    }

    return (
      <div className="gh-racing-racecards">
        <MetaDataWrapper helmetProps={helmetProps}/>
        <JsonLD data={{
          "@id": url,
          "@type": "WebPage",
          breadcrumb: {
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                item: {
                  "@type": "WebSite",
                  "@id": "https://www.sportinglife.com",
                  name: "Sporting Life"
                }
              },
              {
                "@type": "ListItem",
                position: 2,
                item: {
                  "@id": "https://www.sportinglife.com/greyhounds",
                  name: "Greyhounds"
                }
              },
              {
                "@type": "ListItem",
                position: 3,
                item: {
                  "@id": url,
                  name: "Race Cards"
                }
              }
            ]
          }
        }}/>
        <div className="gh-racing-racecards-header-container">
          <h1 className="page-main-title">{title}</h1>
        </div>
        <section className="gh-racing-content">
          {
            meetings && meetings.length > 0 ?
            <ul className="meetings">
              {meetings.map(meeting => (
                <li key={meeting.meeting_summary.meeting_reference.id}>
                  <GreyhoundRacingRacecardsMeetingSummary
                    meeting={meeting}
                    date={racecardsDate}
                    dateIncrement={this.props.dateIncrement}/>
                </li>
              ))}
            </ul>
          :
            <div className="gh-racing-racecards-none">
              <p>No meetings found</p>
            </div>
          }
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRacecardsForDate.js